// extracted by mini-css-extract-plugin
export var breadcrumbs = "breadcrumbs-module--breadcrumbs--2bOUY";
export var breadcrumbs__link = "breadcrumbs-module--breadcrumbs__link--mmiQ6";
export var breadcrumbs__link__active = "breadcrumbs-module--breadcrumbs__link__active--1ciDW";
export var breadcrumbs__span = "breadcrumbs-module--breadcrumbs__span--3AQFK";